import React from 'react'

export default function Login() {
  return (
    <div className="flex flex-col items-center">
      <a
        href="https://central.dartsee.com/auth/google"
        className="text-white text-center uppercase mt-16 py-2 px-4 bg-google-theme rounded-full w-11/12"
      >
        Sign in with google
      </a>
      <a
        href="https://central.dartsee.com/auth/facebook"
        className="text-white text-center uppercase mt-4 py-2 px-4 bg-fb-theme rounded-full w-11/12"
      >
        Sign in with facebook
      </a>
    </div>
  )
}
